import {ConfigurableCartItem, SimpleCartItem} from '__generated__/__types__';

export type CartItem = SimpleCartItem | ConfigurableCartItem;

export enum CartItemType {
    SIMPLE = 'SimpleCartItem',
    CONFIGURABLE = 'ConfigurableCartItem',
}

export enum CartItemStatusEnum {
    NO_STOCK = 102,
    LACK_OF_STOCK = 103,
}
